import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncConfigureCatechism({ ...rest }) {
  const AsyncLoad = loadable(() => import("../page/configCatechism"));
  console.log("Loading", AsyncConfigureCatechism.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncConfigureCatechism;
